// extracted by mini-css-extract-plugin
module.exports = {"list":"articles-list_list__32T6N","item":"articles-list_item__juB8q"};